module.exports = __webpack_public_path__ + "img/1 (142).87087d05.png";